<template>
  <div class="container">
    <div class="u-p-30 bg_FFFFFF u-b-r-8 u-m-t-40 u-m-b-100">
      <!-- <div class="u-font-16 cl_333 fw_600 u-l-h-50">（一）财政性投入产生的科技成果须提供以下材料：</div> -->
      <div class="u-font-14 cl_333 u-l-h-30" v-html="info.value"></div>
        <!-- 1．科技计划项目验收或结项证书；<br>
        2．技术研究报告；<br>
        3．科技查新报告；<br>
        4．检测报告；<br>
        5．1篇SCI论文或2篇中文核心期刊（论文为发表5年以内，只提供成果登记第一完成人所发表的文章，其它完成人的文章不用提供）；<br>
        6．两家单位出具的应用佐证材料（需盖应用单位公章）。 -->
      <!-- <div class="u-font-16 cl_333 fw_600 u-l-h-50">（二）非财政性投入产生的科技成果须提供以下材料：</div>
      <div class="u-font-14 cl_333 u-l-h-30">
        1．技术研究报告；<br>
        2．科技查新报告；<br>
        4．检测报告；<br>
        4．1篇SCI论文或2篇中文核心期刊（论文为发表5年以内，只提供成果登记第一完成人所发表的文章，其它完成人的文章不用提供）；<br>
        5．两家单位出具的应用佐证材料（需盖应用单位公章）。
      </div> -->
    </div>
  </div>
</template>

<script>
import { achievementRegistrationConfig } from '@/api'

export default {
  data() {
    return {
      info: {}
    }
  },
  created() {
    this.getinfo()
  },
  methods: {
    getinfo(){
      achievementRegistrationConfig().then(res => {
        if(res.code === 1){
          this.info = res.data.ar_content
        }
      })
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
/* 响应式设计 */
@media (max-width: 768px) {
 
}
</style>